import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

const isNonProduction = process.env.NODE_ENV !== "production";

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "login",
      component: () => import("./views/Login.vue")
    },
    {
      path: "/logout",
      name: "logout",
      component: () => import("./views/Logout.vue")
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: () => import("./views/controlsoft/dashboards/DashboardPrincipal.vue")
    },
    // Adminstração técnica
    {
      path: "/versoes",
      name: "versoes",
      component: () => import("./views/controlsoft/Versoes.vue")
    },
    {
      path: "/auditoria",
      name: "Auditoria",
      component: () => import("./views/controlsoft/Auditoria.vue")
    },
    {
      path: "/menuscadastro",
      name: "Cadastros de Menus",
      component: () => import("./views/controlsoft/menus/cadastro/cadastromenu.vue")
    },
    {
      path: "/menusvisualizacao",
      name: "Utilização dos Menus",
      component: () => import("./views/controlsoft/menus/visualizacao/visualizacaomenu.vue")
    },
    {
      path: "/menusclientes",
      name: "Configuração de Menus",
      component: () => import("./views/controlsoft/menus/clientes/menusclientes.vue")
    },
    {
      path: "/modulosclientes",
      name: "Configuração de Módulos",
      component: () => import("./views/controlsoft/modulos/clientes/modulosclientes.vue")
    },
    {
      path: "/modulosvisualizacao",
      name: "Utilização dos Módulos",
      component: () => import("./views/controlsoft/modulos/visualizacao/visualizacaomodulos.vue")
    },
    {
      path: "/empresasclientes",
      name: "Configurações de Empresas",
      component: () => import("./views/controlsoft/empresas/clientes/empresasclientes.vue")
    },
    // Outros
    {
      path: "/notificacoes",
      name: "notificacoes",
      component: () => import("./views/Notificacoes.vue")
    },
    {
      path: "/versoes/detalhes/:versao",
      name: "versoesdetalhes",
      props: route => ({ id: route.query.versaodesc }),
      component: () => import("./views/controlsoft/VersoesDetalhes.vue")
    },
    {
      path: "/clientes",
      name: "clientes",
      component: () => import("./views/controlsoft/Clientes.vue")
    },
    {
      path: "/clientes/detalhes/:cliente",
      name: "clientesdetalhes",
      component: () => import("./views/controlsoft/ClientesDetalhes.vue")
    },
    {
      path: "/dbstorage",
      name: "DBStorage",
      component: () => import("./views/controlsoft/DBStorage.vue")
    },
    {
      path: "/consulta/produtoswebmobile",
      name: "Consulta",
      component: () => import("./views/controlsoft/ConsultaProdutosWeb.vue")
    },
    // Integrações
    {
      path: "/integracoes/lar",
      name: "Lar",
      component: () => import("./views/controlsoft/integracoes/Lar.vue")
    },
    {
      path: "/integracoes/larconsulta",
      name: "LarConsulta",
      component: () => import("./views/controlsoft/integracoes/LarConsulta.vue")
    },
    {
      path: "/integracoes/pesador-offline",
      name: "PesadorOffline",
      component: () => import("./views/controlsoft/integracoes/PesadorOffline.vue")
    },
    {
      path: "/integracoes/pesadorconsulta",
      name: "PesadorConsulta",
      component: () => import("./views/controlsoft/integracoes/PesadorConsulta.vue")
    },
    {
      path: "/integracoes/pesadorligacao",
      name: "PesadorLigacao",
      component: () => import("./views/controlsoft/integracoes/PesadorLigacao.vue")
    },
    {
      path: "/integracoes/romaneios-clientes",
      name: "RomaneiosEntreClientes",
      component: () => import("./views/controlsoft/integracoes/RomaneiosEntreClientes.vue")
    },
    {
      path: "/integracoes/romaneios-clientes-consulta",
      name: "RomaneiosEntreClientesConsulta",
      component: () => import("./views/controlsoft/integracoes/RomaneiosEntreClientesConsulta.vue")
    },
    {
      path: "/erros",
      name: "erros",
      component: () => import("./views/controlsoft/Erros.vue")
    },
    {
      path: "/autenticacao-monitor",
      name: "AutenticacaoMonitor",
      component: () => import("./views/controlsoft/Autenticacao_monitor.vue")
    },
    {
      path: "/erros/detalhes/:hash",
      name: "errosdetalhes",
      component: () => import("./views/controlsoft/ErrosDetalhes.vue")
    },
    {
      path: "/atualizacao/cadastro",
      name: "atualizacaoCadastro",
      component: () => import("./views/controlsoft/AtualizacaoCadastro.vue")
    },
    {
      path: "/atualizacao/agenda",
      name: "atualizacaoAgenda",
      component: () => import("./views/controlsoft/AtualizacaoAgenda.vue")
    },
    {
      path: "/atualizacaoarquivos/browse",
      name: "atualizacaoArquivosBrowse",
      component: () => import("./views/controlsoft/AtualizacaoArquivosBrowse.vue")
    },
    {
      path: "/atualizacaoarquivos/cadastro",
      name: "atualizacaoArquivosCadastro",
      component: () => import("./views/controlsoft/AtualizacaoArquivosCadastro.vue")
    },
    {
      path: "/analise_ia_gerencial",
      name: "AnaliseAIGerencial",
      component: () => import("./views/controlsoft/Analise_AI_Gerencial.vue")
    },
    {
      path: "/server/logs",
      name: "ServerLogs",
      component: () => import("./views/controlsoft/server/Logs.vue")
    },
    {
      path: "/server/status",
      name: "ServerStatus",
      component: () => import("./views/controlsoft/server/Status.vue")
    },
    {
      path: "/agronotificacao",
      name: "AgroNotificacao",
      component: () => import("./views/controlsoft/AgroNotificacao.vue")
    },
    {
      path: "/agronotificacao/cadastro/:id",
      name: "AgroNotificacaoCadastro",
      component: () => import("./views/controlsoft/AgroNotificacaoCadastro.vue")
    },
    {
      path: "/agronotificacao/visualizacao/:id",
      name: "AgroNotificacaoVisualizacao",
      component: () => import("./views/controlsoft/AgroNotificacaoCadastro.vue")
    },
    // DataHub
    {
      path: "/datahub/",
      name: "DatahubModelo",
      component: () => import("./views/controlsoft/datahub/Browse.vue")
    },
    {
      path: "/datahub/cadastro/:id",
      name: "DatahubModeloCadastro",
      component: () => import("./views/controlsoft/datahub/Cadastro.vue")
    },
    {
      path: "/datahub/visualizacao/:id",
      name: "DatahubModeloVisualizacao",
      component: () => import("./views/controlsoft/datahub/Cadastro.vue")
    },
    {
      path: "/datahub/:id/views",
      name: "DatahubRelatorios",
      component: () => import("./views/controlsoft/datahub/Resultados.vue")
    },
    // Acompanhamento de Safra - Romaneios
    {
      path: "/acompanhamento-safra",
      name: "AcompanhamentoSafra",
      component: () => import("./views/controlsoft/dashboards/AcompanhamentoSafra.vue")
    },
    // Acompanhamento de Romaneios SySGrão
    {
      path: "/acompanhamento-sysgrao",
      name: "AcompanhamentoSysGrao",
      component: () => import("./views/controlsoft/dashboards/AcompanhamentoSysGrao.vue")
    },
    {
      path: "/monitor-syssupervisor",
      name: "MonitorSysSupervisor",
      component: () => import("./views/controlsoft/dashboards/MonitorSysSupervisor.vue")
    },
    {
      path: "/monitor-agroweb",
      name: "MonitorAgroWeb",
      component: () => import("./views/controlsoft/dashboards/MonitorAgroWeb.vue")
    },
    // DataBridge
    {
      path: "/databrigde/instituicoes-financeiras",
      name: "InstituicoesFinanceiras",
      component: () => import("./views/controlsoft/databrigde/instituicoesFinanceiras.vue")
    },
    {
      path: "/databrigde/reforma-tributaria",
      name: "ReformaTributaria",
      component: () => import("./views/controlsoft/databrigde/reformaTributaria.vue")
    },
    {
      path: "/databrigde/reinf",
      name: "Reinf",
      component: () => import("./views/controlsoft/databrigde/reinf.vue")
    },
    {
      path: "/databrigde/adapar",
      name: "Adapar",
      component: () => import("./views/controlsoft/databrigde/adapar.vue")
    },
    {
      path: "/databrigde/indea",
      name: "Indea",
      component: () => import("./views/controlsoft/databrigde/indea.vue")
    },
    {
      path: "/databrigde/bayer",
      name: "Bayer",
      component: () => import("./views/controlsoft/databrigde/bayer.vue")
    },
    {
      path: "/databrigde/nexxera",
      name: "Nexxera",
      component: () => import("./views/controlsoft/databrigde/nexxera.vue")
    },
    {
      path: "/databrigde/responsavel-tecnico",
      name: "SoftHouse",
      component: () => import("./views/controlsoft/databrigde/softHouse.vue")
    },
    ...(isNonProduction
      ? [
          {
            path: "/databrigde/auditoria",
            name: "AuditoriaDataBridge",
            component: () =>
              import("./views/controlsoft/databrigde/auditoria.vue")
          }
        ]
      : []),
    {
      path: "/databrigde/base-conhecimento",
      name: "BaseConhecimento",
      component: () => import("./views/controlsoft/databrigde/baseConhecimento.vue")
    },
    {
      path: "/databrigde/faq",
      name: "Faq",
      component: () => import("./views/controlsoft/databrigde/faq.vue")
    },
    // CS API
    {
      path: "/csapi/admin-instrument",
      name: "AdminInstrument",
      component: () => import("./views/controlsoft/csapi/adminInstrument.vue")
    },
    // SySafra
    {
      path: "/sysafra/sysbackup/monitor",
      name: "SysBackupDashboard",
      component: () => import("./views/sysafra/sysbackup/Monitor.vue")
    },
    {
      path: "/sysafra/sysbackup/solicitacoes",
      name: "SysBackupSolicitacoes",
      component: () => import("./views/sysafra/sysbackup/SolicitacaoBackup.vue")
    },
    {
      path: "/sysafra/sysbackup/validacoes",
      name: "SysBackupValidacoes",
      component: () => import("./views/sysafra/sysbackup/ValidacoesBackup.vue")
    },
    {
      path: "/sysafra/sysbackup/clientes",
      name: "SysBackupClientes",
      component: () => import("./views/sysafra/sysbackup/clientes/Index.vue")
    },
    {
      path: "/sysafra/sysbackup/clientes/:cliente/historico-backups",
      name: "SysBackupHistoricoBackups",
      component: () => import("./views/sysafra/sysbackup/clientes/HistoricoBackups.vue")
    },
    {
      path: "/sysafra/sysbackup/config",
      name: "SysBackupConfig",
      component: () => import("./views/sysafra/sysbackup/Config.vue")
    },
    {
      path: "/dicionario-tradutor",
      name: "DicionarioTradutor",
      component: () => import("./views/controlsoft/Tradutor.vue")
    },
    // Out of box
    {
      path: "/releases",
      name: "releases",
      component: () => import("./views/controlsoft/releases.vue")
    },
    {
      path: "/releases/:id",
      name: "releasesVersao",
      component: () => import("./views/controlsoft/releasesVersao.vue")
    },
    {
      path: "/mapa-clientes",
      name: "mapaClientes",
      component: () => import("./views/controlsoft/MapaClientes.vue")
    }
  ]
});

router.beforeEach((to, from, next) => {
  const { user } = store.state.auth;
  const token = store.state.auth.auth;

  if (to.name === "releases" || to.name === "releasesVersao") {
    next();
  } else if (to.name !== "logout" && to.name !== "login" && (!user || !token)) {
    next({ name: "login" });
  } else {
    next();
  }
});

export default router;
